// import { app_config } from "./app.config";

export const api_paths = {
  //   PUBLIC_PATH:
  //     app_config.server_type === "LOCAL"
  //       ? app_config.axios_config.public_base_url_local
  //       : app_config.server_type === "DEVELOPMENT"
  //       ? app_config.axios_config.public_base_url_development
  //       : app_config.axios_config.public_base_url_live,
  auth: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    VERIFY_OTP: "/auth/verify-register-otp",
    RESEND_OTP: "/auth/resend-register-otp",
    FORGOT_PASSWORD: "/auth/forgot-password",
    VERIFY_FORGOT_PASSWORD_OTP: "/auth/verify-forgot-password-otp",
    LOGOUT: "/auth/logout",
    VERIFY_EMAIL: "/auth/verify-email",
    GUEST_SEND_OTP: "/auth/guest-send-otp",
    GUEST_VERIFY_OTP: "/auth/guest-verify-otp",
  },
  member: {
    GET_USER: "/member",
    EDIT_USER: "/member",
    EDIT_PHONE: "/member/update-phone",
    VERIFY_OTP: "/member/verify-update-phone",
    RESEND_OTP: "/member/resend-update-phone",
    CHANGE_PASSWORD: "member/change-password",
    EDIT_PROFILE: "/member/profile-picture",
    DELETE_PROFILE: "/member/profile-picture",
    RESEND_VERIFICATION_EMAIL: "/member/resend-verification-email",

    EVENTS: {
      GET_LIST: "/member/event/list",
      EVENT: "/member/event",
      EVENT_PAGE: {
        GET_LIST: "member/event/list",
        EVENT_DETAIL: "member/event/",
      },
      ALL_TICKET: "member/event/all-ticket",
      PURCHASED_TICKETS: "member/event/purchased-tickets",
      RSVP_MEMBERS: "member/event/rsvp-members",
      EVENT_GALLERY_PAGE: {
        GET_LIST: "/member/event-gallery/list",
        GET_EVENT_IMAGES: "/member/event-gallery/gallery-image",
      },
    },
    family_member: {
      DELETE_MEMBER: "member/family-member/delete",
      GET_MEMBER: "member/family-member/list",
      ADD_MEMBER: "member/family-member/add",
      UPDATE_MEMBER: "/member/family-member/update",
      GET_RELATIONSHIP: "/member/family-member/relationship",
      EDIT_PROFILE: "member/family-member/profile-picture/",
      DELETE_PROFILE: "member/family-member/profile-picture/",
    },
    membership: {
      GET_PLAN: "member/membership/plan",
      GET_ALL_PLANS: "member/membership/all-plans",
      PAST_MEMBERSHIP_LIST: "/member/membership/past-membership",
    },
    payment: {
      PROCESS_TO_PAY_MEMBERSHIP: "member/payment/checkout",
      EVENT_CHECKOUT: "member/payment/event-checkout",
      DONATE_CHECKOUT: "member/payment/donate-checkout",
    },
    transaction: {
      TRANSACTION_LIST: "member/transaction/list",
    },
    HOME: {
      GET_BANNER: "/member/home/banner",
      GET_UPCOMING_EVENTS: "/member/home/upcoming-latest-event",
      GET_OTHER_DETAILS: "/member/home/",
    },
    CONTACT_US: {
      FORM: "member/contact-us",
      COMMITTEE: "member/committee/list?is_board_of_governor=false",
    },
    SPONSORS: {
      GET_SPONSORS: "member/sponsor/list",
    },
    PAST_PRESIDENTS: {
      GET_LIST: "member/past-president/list",
      GET_DETAILS: "member/past-president",
    },
    FAQ: {
      GET_LIST: "member/faqs/list",
    },
    USER_GUIDE: {
      GET_LIST: "member/user-guide/list", // Assuming pattern
    },
    NOMINATION: {
      GET_SETTING: "/member/nomination/setting",
      SUBMIT: "/member/nomination/submit",
    },
  },
  address: {
    GET_COUNTRY: "/country",
    GET_STATE: "/state",
    GET_CITY: "/city",
  },
  committee: {
    GET_COMMITTEE_MEMBER: "member/committee/list",
    GET_COMMITTEE_MEMBER_DETAIL: "member/committee",
  },
  GET_CMS_PAGE: "/member/cms/",
};
